// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_bq-0";
export var orangeButton = "_bq-1";